import PopupBanner from './PopupBanner';

export default PopupBanner;
